module.exports = __webpack_public_path__ + "img/11重合同守信用企业证书2.9b000976.png";